import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import './styles.css'

class StartTripControls extends Component {
  static propTypes = {
    startTrip: PropTypes.func.isRequired,
    goToCurrentLocation: PropTypes.func,
    hasCurrentLocation: PropTypes.bool
  }

  static defaultProps = {
    goToCurrentLocation: () => {
      alert('Go To Current Loc!');
    },
    hasCurrentLocation: false
  }

  state = {
    classToggle: false,
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.payMeAttention()
    }, 1500)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onMouseOver = () => {
    clearInterval(this.interval)
  }

  onMouseOut = () => {
    this.interval = setInterval(() => {
      this.payMeAttention()
    }, 1500)
  }

  payMeAttention() {
    this.setState({
      classToggle: !this.state.classToggle,
    })
  }

  render() {
    const { onMouseOver, onMouseOut, } = this
    const { startTrip, goToCurrentLocation, hasCurrentLocation } = this.props
    const { classToggle, } = this.state
    const payMeAttentionClass = classToggle ? 'pay-me-attention' : ''
    return (
      <div className="start-trip-controls">
        <div
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
          className={`start-trip-button-container ${payMeAttentionClass}`}
        >
          <button
            onClick={() => {
              startTrip()
            }}
          >
            Start Trip
          </button>
          { hasCurrentLocation &&
            <button
              onClick={() => {
                goToCurrentLocation()
              }}
            >
              Current Location
            </button>
          }
        </div>
      </div>
    )
  }
}

export default StartTripControls



// WEBPACK FOOTER //
// ./src/components/StartTripControls/index.js